import { useAppSelector } from './useAppSelector';

export const useLayoutState = () => {
    const { hoc_ky, nam_hoc , id_kh} = useAppSelector(x => x.common.layout)
    return {
        hoc_ky,
        nam_hoc,
        id_kh
    };
}